import { type TemplateVariable } from "./AgentRecord";

/**
 * The variables an agent cannot start without: required, and with no default
 * to fall back on. A launch or a trigger that leaves one empty fails, so a
 * form insists on these.
 */
export function requiredWithoutDefault(
  variables: readonly TemplateVariable[],
): string[] {
  return variables
    .filter(
      (variable) =>
        variable.required &&
        (variable.default === undefined || variable.default === null),
    )
    .map((variable) => variable.name);
}
